import _ from 'underscore';
import {
  CONSTANTS,
  ProjectionGridBaseColumn,
} from '@bingads-webui/projection-grid-base-column';
import { customColumnGridKeyFromId } from '@bingads-webui-universal/custom-column-utils';

import helpContentTemplate from './help-content-template.pug';

export class CustomColumn extends ProjectionGridBaseColumn {
  constructor(columnConfig) {
    const {
      i18n,
      id,
      name,
      format,
      description,
    } = columnConfig;

    if (!id) {
      throw new Error('CustomColumn requires an id');
    }

    let displayFormat;

    if (format === 'Percentage') {
      displayFormat = CONSTANTS.COLUMN_FORMATS.PERCENTAGE_VALUE;
    } else {
      displayFormat = CONSTANTS.COLUMN_FORMATS.DECIMAL;
    }

    super(_.defaults({
      title: name,
      name: `CustomColumn${id}`,
      sortable: true,
      type: CONSTANTS.COLUMN_TYPES.NUMBER,
      format: displayFormat,
      helpId: 'pop_BA_Campaign_CustomCol_Name',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: name }),
      property: customColumnGridKeyFromId(id),
      customHelpContent: encodeURIComponent(helpContentTemplate({ name, description })),
      colClasses: [
        'performance-metrics',
        `performance-metrics-custom-column-${id}`,
      ],
    }, columnConfig));

    this.config.customColumnId = id;
  }

  /**
   * The custom-column's GUID prefixed with appropriate OData identifier(s).
   * EXAMPLE: "PerformanceMetrics/CustomColumn470e5a8366ea928fd8e05ba816cc5982"
   */
  get odataId() {
    return customColumnGridKeyFromId(this.config.customColumnId);
  }

  /**
   * A custom column differs from a normal column in that its title should be
   * set to the name defined by the user when creating the column.
   */
  get title() {
    return this.config.title;
  }

  get property() {
    const { customColumnId, property } = this.config;

    return {
      key: property,
      get(data) {
        let value = -1;

        if (data.PerformanceMetrics) {
          value = _.result(data.PerformanceMetrics, `CustomColumn${customColumnId}`);
        }

        return value;
      },
    };
  }
}
